import React, { SyntheticEvent, useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../hooks/hooks";
import { Grid, Typography } from "@mui/material";
import TableTemplate from "../../../../reusableComponents/tableTemplate/tableTemplate";
import { MRT_ColumnDef, useMaterialReactTable } from "material-react-table";
import { useQuery } from "react-query";
import { getAssociatedProduct } from "../../../../../store/thunks/portalManagementThunk";

const FrequentlyPurchased = () => {
  const { associatedProductData } = useAppSelector(
    (state: any) => state.portalManagement
  );

  useEffect(() => {
    refetch();
  }, [associatedProductData]);

  const {
    data: { data = [] } = {},
    isError,
    isRefetching,
    isLoading,
    refetch,
  } = useQuery<any>({
    queryKey: ["table-data"],
    queryFn: async () => {
      const response: any = {};

      return response ? response : {};
    },
  });

  const frequentlyPurchasedColumns = useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        id: "Table",
        header: "",
        columns: [
          {
            accessorKey: "antecedents",
            enableClickToCopy: true,
            filterVariant: "autocomplete",
            header: "Customer Bought",
          },
          {
            accessorKey: "consequents",
            enableClickToCopy: true,
            filterVariant: "autocomplete",
            header: "Often Bought With Consequent",
          },
          {
            accessorKey: "confidence",
            header: "Probability",
          },
        ],
      },
    ],
    []
  );

  const frequentlyPurchasedTable = useMaterialReactTable({
    columns: frequentlyPurchasedColumns,
    data: associatedProductData?.data ? associatedProductData?.data : [],
    state: {
      isLoading: isLoading,
    },
    enableColumnFilterModes: true,
    enableColumnOrdering: true,
    enableGrouping: true,
    enableColumnPinning: false,
    enableFacetedValues: true,
    enableRowSelection: false,
    initialState: {
      showColumnFilters: true,
      showGlobalFilter: true,
      pagination: { pageIndex: 0, pageSize: 10 },
      columnPinning: {
        left: ["mrt-row-expand", "mrt-row-select"],
        right: ["mrt-row-actions"],
      },
    },
    positionToolbarAlertBanner: "bottom",
    muiSearchTextFieldProps: {
      size: "small",
      variant: "outlined",
    },
    enablePagination: false,
    enableRowNumbers: true,
    enableRowVirtualization: true,
    manualFiltering: true,
    manualSorting: true,
    muiTableContainerProps: {
      sx: { maxHeight: "400px" },
    },
    renderBottomToolbarCustomActions: () => (
      <Typography>{associatedProductData?.data?.length} total rows.</Typography>
    ),
  });

  return (
    <Grid container item xs={12} sx={{ padding: "20px 0px 20px 0px" }}>
      <TableTemplate tableData={frequentlyPurchasedTable} />
    </Grid>
  );
};

export default FrequentlyPurchased;
